module.exports = __webpack_public_path__ + "svg/new-interac-big.633383c6cd9f32541088b2c6ece8ba7f.svg";